import {
    type NextLocale,
    venueConfig,
    type VenueId,
} from '@beat-venues/common-types';

export const getEventDetailLink = (
    venueId: VenueId,
    slug: string,
    locale: NextLocale,
    type?: 'event' | 'news'
) => {
    const event = {
        nl: 'evenement',
        en: 'event',
        fr: 'evenement',
    };

    const news = {
        nl: 'nieuws',
        en: 'news',
        fr: 'nouvelles',
    };

    if (!slug) {
        return;
    }
    const domain = venueConfig(venueId, 'vite').url;

    return `${domain}${locale}/${
        type === 'news' ? news[locale] : event[locale]
    }/${slug}`;
};
